import { useCallback } from "react";

import styled from "@emotion/styled";
import { Calendar } from "@natscale/react-calendar";
import { format, isBefore, startOfDay } from "date-fns";

import { dateStringToDate } from "@/components/pages_logged_in/schedule/timeslots/date-string-to-date";

interface CalendarWidgetProps {
  dateString: string;
  setDateString: (dateString: string) => void;
  availableDates: Record<string, boolean>;
  toggleDisplayMode?: () => void;
}

export function CalendarWidget({
  dateString,
  setDateString,
  availableDates,
  toggleDisplayMode,
}: CalendarWidgetProps) {
  const isDisabled = useCallback(
    (date: Date) => {
      if (isBefore(startOfDay(date), startOfDay(new Date()))) {
        return true;
      }
      const dateString = format(date, "MM-dd-yyyy");
      return !availableDates[dateString];
    },
    [availableDates],
  );

  return (
    <div className="items-center">
      <CalendarStyled>
        <div className="calendar-ratio">
          <div className="inner-ration">
            <Calendar
              className="exec-calendar"
              value={dateStringToDate(dateString)}
              startOfWeek={0}
              onChange={(newDate) => {
                if (newDate) {
                  setDateString(format(newDate as Date, "MM-dd-yyyy"));
                  toggleDisplayMode?.();
                }
              }}
              isDisabled={isDisabled}
              fontSize={18}
              weekends={[]}
              isMultiSelector={false}
            />
          </div>
        </div>
      </CalendarStyled>
    </div>
  );
}

const CalendarStyled = styled.div`
  .calendar-ratio {
    width: 100%;
    padding-top: 100%;
    position: relative;

    .inner-ration {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;

      .rc_root {
        width: 100%;
        height: 100%;

        .rc {
          width: 100% !important;
          height: 100% !important;
        }
      }
  }
`;
